export default __webpack_public_path__ + "static/media/DPT.49278dbb.png";